import {useEffect} from "preact/hooks";
import {XMarkIcon} from "@heroicons/react/24/solid";

export function LoginDialog({showDialog, setShowDialog}) {

    useEffect(() => {
        const handleClick = (e) => {
            const isInsideDialog = e.target.closest("#login-dialog") !== null;
            const isAddFavorite = e.target.closest("#add-favorite") !== null;
            if (!isInsideDialog && !isAddFavorite) {
                setShowDialog(false);
            }
        };
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, [setShowDialog]);

    return (
        <div
            id="login-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="login-dialog-title"
            className={`${showDialog ? 'block' : 'hidden'} fixed top-0 left-0 right-0 z-50 p-4 overflow-x-hidden overflow-y-auto h-[calc(100%-1rem)] max-h-full bg-black/50 flex justify-center items-start`}
        >
            <div className="relative bg-white rounded-lg shadow-sm w-full max-w-md mx-auto mt-40">
                <button
                    aria-label="Close dialog"
                    onClick={() => setShowDialog(false)}
                    className="w-8 h-8 cursor-pointer absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                >
                    <XMarkIcon className="w-full h-full"/>
                </button>
                <div className="p-6 text-center space-x-4 space-y-4">
                    <h2 id="login-dialog-title" className="text-gray-900">Login required</h2>
                    <p>
                        Please login before adding the song to your favorite list. Do not have an account
                        yet? Sign up here
                    </p>
                    <a href="/account" className="primary-btn text-white">
                        Log in
                    </a>
                    <a href="/signup" className="secondary-btn text-red-400">
                        Sign up
                    </a>
                </div>
            </div>
        </div>
    );
}
